import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { IClientCreatedResult } from "@ramudden/models/application";
import { AccessibilityService } from "@ramudden/services";
import { DialogComponentBase } from "apps/portal/src/app/shared/components/dialog/dialog.component";
import { Dialog } from "primeng/dialog";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";

@Component({
    selector: "app-application-create-result-dialog",
    templateUrl: "./application-create-result.dialog.html",
    imports: [Dialog, TranslateModule, SvgIconComponent],
})
export class ApplicationCreateResultDialogComponent extends DialogComponentBase {
    clientCreatedResult: IClientCreatedResult;
    copiedSecret: boolean;

    constructor(private readonly accessibilityService: AccessibilityService) {
        super();

        this.dismissOnClickOutside = false;
    }

    open(clientCreatedResult: IClientCreatedResult) {
        this.clientCreatedResult = clientCreatedResult;

        this.openDialog();
    }

    protected onClose() {
        this.copiedSecret = false;
        this.clientCreatedResult = null;
    }

    copyIdToClipboard() {
        this.accessibilityService.copyToClipboard(
            this.clientCreatedResult.id,
            "applications.copiedClientIdToClipboard",
        );
    }

    copySecretToClipboard() {
        this.copiedSecret = true;
        this.accessibilityService.copyToClipboard(
            this.clientCreatedResult.secret,
            "applications.copiedClientSecretToClipboard",
        );
    }
}
